
export async function checkIfImageLoads(src: string): Promise<boolean> {
    return new Promise(resolve => {
        if (!src) {
            resolve(false);
            return;
        }

        const image = new Image();
        image.addEventListener('load', () => resolve(true));
        image.addEventListener('error', () => {
            resolve(false);
        });
        image.src = src;
    });
}
